import { render } from "./datasetMapping.vue?vue&type=template&id=1af53cf8&ts=true"
import script from "./datasetMapping.vue?vue&type=script&lang=ts"
export * from "./datasetMapping.vue?vue&type=script&lang=ts"

import "./datasetMapping.vue?vue&type=style&index=0&id=1af53cf8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__